<template>
  <b-card class="mb-1">
    <b-form @submit.prevent="emitBuscar">
      <!-- Fila 1: Búsqueda, Estado, Tipo de paquete -->
      <b-row>
        <b-col cols="12" md="3">
          <b-form-group label="Búsqueda" label-for="search">
            <b-form-input id="search" v-model.trim="filters.search" placeholder="Paciente, paquete, orden..." />
          </b-form-group>
        </b-col>

        <b-col cols="12" md="3">
          <b-form-group label="Estado" label-for="estado">
            <b-form-select id="estado" v-model="filters.estado" :options="estadoOptions" />
          </b-form-group>
        </b-col>

        <b-col cols="12" md="3">
          <b-form-group label="Tipo de paquete" label-for="tipoPaquete">
            <b-form-select id="tipoPaquete" v-model="filters.tipoPaquete" :options="tipoPaqueteOptions" />
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Fila 2: Fechas y acciones -->
      <b-row>
        <b-col cols="12" md="3">
          <b-form-group label="Desde" label-for="fdesde">
            <b-form-input type="date" id="fdesde" v-model="filters.fechaDesde" />
          </b-form-group>
        </b-col>

        <b-col cols="12" md="3">
          <b-form-group label="Hasta" label-for="fhasta">
            <b-form-input type="date" id="fhasta" v-model="filters.fechaHasta" />
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6" class="d-flex align-items-end">
          <b-button variant="primary" class="mr-1" @click="emitBuscar">
            <feather-icon icon="SearchIcon" class="mr-25"/> Buscar
          </b-button>
          <b-button variant="outline-secondary" class="mr-1" @click="limpiar">
            Limpiar
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
export default {
  name: 'FilterPaquetes',
  data() {
    return {
      filters: {
        search: '',
        estado: '',
        tipoPaquete: '',
        fechaDesde: null,
        fechaHasta: null,
      },
      estadoOptions: [
        { value: '', text: 'Todos' },
        { value: 'ACTIVO', text: 'Activo' },
        { value: 'INACTIVO', text: 'Inactivo' },
      ],
      tipoPaqueteOptions: [
        { value: '', text: 'Todos' },
        { value: 'BASICO', text: 'Básico' },
        { value: 'INTERMEDIO', text: 'Intermedio' },
        { value: 'FULL', text: 'Full' },
      ],
    };
  },
  created(){
    const ls = localStorage.getItem('filterPaquetesPrev');
    if(ls){ try{ this.filters = JSON.parse(ls) } catch(e){} }
  },
  methods: {
    emitBuscar(){
      this.$emit('filter-change', { ...this.filters });
      this.$emit('buscar');
    },
    limpiar(){
      this.filters = { search: '', estado: '', tipoPaquete: '', fechaDesde: null, fechaHasta: null };
      this.emitBuscar();
    },
  }
}
</script>
